import { useQuery } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';
import type { IUserPush } from '@/interfaces';

type TParams = {
	userId: string;
};

export const useRequestGetUserPushes = ({ userId }: TParams, run = true) => {
	const { isLoading, data, error } = useQuery({
		queryKey: [routes.api.users.base, 'pushes', userId],
		queryFn: () =>
			apiClient
				.get<IUserPush[]>(routes.api.users.pushes(userId))
				.then(handleApiResponse),
		enabled: run && !!userId,
		staleTime: 30_000,
	});

	return {
		isLoadingPushes: isLoading,
		pushes: data ?? [],
		error,
	};
};
